import  { FC } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface InputErrorProps {
  error?: string;
}

const animationHeight = {
  show: { height: 'auto', opacity: 1 },
  hide: { height: 0, opacity: 0 },
};

const InputError: FC<InputErrorProps> = ({ error }) => {
  return (
    <AnimatePresence>
    <>
      {error && (
        <motion.div animate={error ? 'show' : 'hide'} initial="hide" exit="hide" variants={animationHeight}>
          <p className="text-xs text-red" role="alert">
            {error}
          </p>
           </motion.div>
      )}
      </>
        </AnimatePresence> 
  );
};

export default InputError;
